import { render, staticRenderFns } from "./AppAgroSettings.vue?vue&type=template&id=cbb0ce0e&scoped=true&"
import script from "./AppAgroSettings.vue?vue&type=script&lang=js&"
export * from "./AppAgroSettings.vue?vue&type=script&lang=js&"
import style0 from "./AppAgroSettings.vue?vue&type=style&index=0&id=cbb0ce0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb0ce0e",
  null
  
)

export default component.exports